import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useResource } from "@hooks/useResource";

import { getTypeParam, getAdvancedPeriodStringParam } from "@helpers/general";

import BarChartCardWrapper from "../BarChartCardWrapper";
import ErrorPage from "@components/Common/ErrorPage";
import SpinnerWrapper from "@components/Common/SpinnerWrapper";

export default function Top10ShopsRow({
    type,
    period,
    designation,
}: StatisticsChartsRowsPropsType) {
    const { t } = useTranslation();
    const advancedDate = useSelector(
        (state: AdvancedDateStateType) => state.advancedDate
    );

    const [data, setData] = React.useState<number[]>([]);
    const [labels, setLabels] = React.useState<string[]>([]);

    const { resourceData, error } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/dashboard/top-10-shops?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            designation && designation !== "my_favorites"
                ? `&selected=${designation}`
                : ""
        }`
    );

    React.useEffect(() => {
        let localData: number[] = [];
        let localLabels: string[] = [];

        resourceData.data?.forEach((item: any) => {
            localLabels.push(item.designation);
            localData.push(item.value);
        });

        setData(localData.slice(0, 10));
        setLabels(localLabels.slice(0, 10));
    }, [resourceData]);

    const top10ShopsInitData: SerieType[] = [
        {
            name: type,
            data: [...data, ...Array(10 - data.length).fill(0)],
        },
    ];

    return (
        <React.Suspense fallback={<SpinnerWrapper />}>
            {error ? (
                <ErrorPage />
            ) : (
                <BarChartCardWrapper
                    title={t("Top 10 stores")}
                    series={top10ShopsInitData}
                    categories={[
                        ...labels,
                        ...Array(10 - labels.length).fill(""),
                    ]}
                    type={type}
                />
            )}
        </React.Suspense>
    );
}
